import { connect } from 'react-redux';
import { withTranslation } from '@piwikpro/ui-components';
import IPAnonimization from './IPAnonimization';

const mapStateToProps = (state: any) => ({
  settings: state.trackerSettings.global.settings,
  isLoading: state.trackerSettings.global.isLoading,
  failed: state.trackerSettings.global.failed,
});

export const ConnectedIPAnonimization = connect(mapStateToProps, null)(IPAnonimization);

export default withTranslation(['administration'])(ConnectedIPAnonimization as any);
